import { createContext, useContext } from 'react';

export const generateContext = <T>() => {
  const ctx = createContext<T | null>(null);
  const provider = ctx.Provider;
  const useTheContext = () => {
    const useCtx = useContext(ctx);
    if (useCtx === null) {
      throw new Error('Provider cannot be null. Please add a context-provider');
    }
    return useCtx;
  };
  return [provider, useTheContext] as const;
};
